import { useState } from 'react'
import {
	Box,
	Button,
	TextField,
	Typography,
	Alert,
	CircularProgress,
	Paper
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import useLogin from '../hooks/useLogin'
import { useAppSelector } from '../redux/hooks'
import { ArrowBack, Email } from '@mui/icons-material'

export const ForgotPassword = () => {
	const { forgotPasswordHandler } = useLogin()
	const { loading } = useAppSelector((state) => state.auth)
	const navigate = useNavigate()

	const [email, setEmail] = useState('')
	const [message, setMessage] = useState('')
	const [error, setError] = useState('')
	const [emailSent, setEmailSent] = useState(false)

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		
		if (!email) {
			setError('Por favor, ingresa tu email.')
			return
		}

		setError('')
		setMessage('')

		const result = await forgotPasswordHandler(email)
		
		if (result.success) {
			setEmailSent(true)
			setMessage(result.message)
		} else {
			setError(result.message)
		}
	}

	const handleBackToLogin = () => {
		navigate('/login')
	}

	return (
		<Box 
			display="flex" 
			justifyContent="center" 
			alignItems="center" 
			minHeight="100vh"
			sx={{ backgroundColor: '#f5f5f5', padding: 2 }}
		>
			<Paper 
				elevation={6} 
				sx={{ 
					padding: 4, 
					maxWidth: 500, 
					width: '100%',
					borderRadius: 2
				}}
			>
				<Box display="flex" justifyContent="center" marginBottom={3}>
					<img src="/assets/ICTALogo.png" alt="ICTA Logo" width="120" height="120" />
				</Box>

				<Typography variant="h4" component="h1" gutterBottom textAlign="center">
					Recuperar Contraseña
				</Typography>

				{!emailSent ? (
					<>
						<Typography variant="body1" color="textSecondary" textAlign="center" marginBottom={3}>
							Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
						</Typography>

						<Box component="form" onSubmit={handleSubmit} width="100%">
							<TextField
								fullWidth
								label="Email"
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								variant="outlined"
								margin="normal"
								required
								disabled={loading}
								InputProps={{
									startAdornment: <Email sx={{ color: 'action.active', mr: 1 }} />
								}}
							/>

							{error && (
								<Alert severity="error" sx={{ marginY: 2 }}>
									{error}
								</Alert>
							)}

							<Button
								type="submit"
								fullWidth
								variant="contained"
								size="large"
								disabled={loading}
								sx={{ 
									marginY: 2,
									backgroundColor: '#177C3B',
									'&:hover': {
										backgroundColor: '#145a2e'
									}
								}}
							>
								{loading ? (
									<CircularProgress size={24} color="inherit" />
								) : (
									'Enviar Email de Recuperación'
								)}
							</Button>
						</Box>
					</>
				) : (
					<Box textAlign="center">
						<Alert severity="success" sx={{ marginY: 2 }}>
							{message}
						</Alert>
						
						<Typography variant="body1" color="textSecondary" marginY={2}>
							Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.
						</Typography>
						
						<Typography variant="body2" color="textSecondary" marginY={2}>
							Si no recibes el email en unos minutos, revisa tu carpeta de spam.
						</Typography>
					</Box>
				)}

				<Box display="flex" justifyContent="center" marginTop={3}>
					<Button
						startIcon={<ArrowBack />}
						onClick={handleBackToLogin}
						variant="text"
						sx={{ color: '#177C3B' }}
					>
						Volver al Login
					</Button>
				</Box>
			</Paper>
		</Box>
	)
}
